const customModalHomeAdminForm = {
  'custom-home-modal-admin-form-message-label': 'Imagen pagina de inicio',
  'custom-home-modal-admin-title': 'Modal personalizado de la página de inicio',
  'custom-home-modal-admin-description': 'Administra la imagen y visibilidad del modal de inicio.',
  'custom-home-modal-admin-form-status-label-deactivated': 'Activar',
  'custom-home-modal-admin-form-status-label-activated': 'Desactivar',
  'custom-home-modal-admin-error-required': 'Este campo es obligatorio.',
  'custom-home-modal-admin-subbmiting-message': 'Guardando configuración del modal...',
  'custom-home-modal-admin-getting-details': 'Obteniendo detalles imagen inicio...',
  'custom-home-modal-admin-img-loader-info': 'Sube una imagen que se mostrará en el modal de inicio.',
  'custom-home-modal-admin-image-setting-successfull': 'La imagen de la página de inicio se ha establecido correctamente',
  'custom-home-modal-admin-boton-change-img': 'Cambiar imagen',
  'custom-home-modal-admin-boton-accept': 'Aceptar',
  'custom-home-modal-admin-boton-show-modal': 'Ver cartel inicio',
  'custom-home-modal-admin-img-not-found': 'Imagen no encontrada o aún no configurada'
};

export default customModalHomeAdminForm;
